module.exports = __webpack_public_path__ + "static/media/navigate-booking.a322957e.svg";